import { useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getAward,
  getAwards,
  getMyAwardEntry,
  getAwardEntries,
  registerAwardEntry,
  votingAwardEntry,
  checkVotedAwardEntry,
  deleteAwardEntry,
  resetFormRegisterAwardEntry,
} from "./../../../pages/Award/redux/actions"

export const useAward = (params) => {
  const dispatch = useDispatch();
  const { award, entries } = useSelector(state => state.awardReducers);

  useEffect(() => {
    dispatch(getAward(params));
  }, [params, dispatch, getAward]);

  return [award, entries]
};

export const useAwards = (request_params) => {
  const dispatch = useDispatch();
  const { awards, params } = useSelector(state => state.awardReducers);

  useEffect(() => {
    dispatch(getAwards(request_params));
  }, [request_params, dispatch, getAwards]);

  return [awards, params]
};

export const useMyAwardEntry = (params = null) => {
  const dispatch = useDispatch();
  const { entry } = useSelector(state => state.awardReducers);

  useEffect(() => {
    dispatch(getMyAwardEntry(params));
  }, [params, dispatch, getMyAwardEntry]);

  return [entry]
};

export const useAwardEntry = (request_params) => {
  const dispatch = useDispatch();
  const { entries, isProcessing, entries_params } = useSelector(state => state.awardReducers);

  useEffect(() => {
    dispatch(getAwardEntries(request_params));
  }, [request_params, dispatch, getAwardEntries]);

  return [entries, isProcessing, entries_params]
};

export const useRegisterAwardEntry = () => {
  const dispatch = useDispatch();
  const { isLoadingForm, registerFailed, type } = useSelector(state => state.awardReducers);
  const [registerSuccess, setRegisterSuccess] = useState(false)

  const handleSubmit = values => {
    dispatch(registerAwardEntry(values));
  };

  useEffect(() => {
    if (type === 'REGISTER_AWARD_SUCCESS') {
      setRegisterSuccess(true)
    }
  }, [type])

  return [isLoadingForm, handleSubmit, registerFailed, registerSuccess];
};

export const useClearRegisterAwardEntry = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      if (!data) {
        dispatch(resetFormRegisterAwardEntry());
      }
    };
  }, [data]);
};

export const useDeleteEntry = () => {
  const dispatch = useDispatch();
  const { isLoadingForm, deleteEntryFailed, type } = useSelector(state => state.awardReducers);
  const [deleteSuccess, setDeleteSuccess] = useState(false)

  const handleSubmit = values => {
    dispatch(deleteAwardEntry(values));
  };

  useEffect(() => {
    if (type === 'DELETE_AWARD_ENTRY_SUCCESS') {
      setDeleteSuccess(true)
    }
  }, [type])

  return [isLoadingForm, handleSubmit, deleteEntryFailed, deleteSuccess];
};

export const useSubmitAwardVote = () => {
  const dispatch = useDispatch();
  const { isLoadingForm, votingFailed, type } = useSelector(state => state.awardReducers);
  const [voteSuccess, setVoteSuccess] = useState(false)

  const handleSubmit = values => {
    dispatch(votingAwardEntry(values));
  };

  useEffect(() => {
    if (type === 'VOTING_AWARD_SUCCESS') {
      setVoteSuccess(true)
    }
  }, [type])

  return [isLoadingForm, handleSubmit, voteSuccess];
};


export const checkVoted = () => {
  const dispatch = useDispatch();
  const { voted } = useSelector(state => state.awardReducers);

  useEffect(() => {
    dispatch(checkVotedAwardEntry());
  }, [dispatch, getAwardEntries]);

  return [voted]
};
